import type { DefinitionNode, OperationDefinitionNode } from "graphql";
import { parse } from "graphql";

const isOperationDefinitionNode = (
  definitionNode: DefinitionNode,
): definitionNode is OperationDefinitionNode =>
  definitionNode.kind === "OperationDefinition" && !!definitionNode.name?.value;

const getOperationDefinition = (
  definitions: ReadonlyArray<DefinitionNode>,
): OperationDefinitionNode | undefined =>
  definitions.find(isOperationDefinitionNode);
export const getOperationName = (doc: string): string => {
  const parsed = parse(doc);
  const definition = getOperationDefinition(parsed.definitions);
  return definition?.name?.value || "unknown";
};
